/* Glow Áine micro-delights: sparkle burst on add-to-bag and a cart icon bounce. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastPoint = null;

  document.addEventListener('pointerdown', function (e) {
    var btn = e.target.closest('button[name="add"], button[type="submit"], .ga-add, [ref="addToCartButton"], .add-to-cart-button, .quick-add__button');
    if (btn) {
      var r = btn.getBoundingClientRect();
      lastPoint = { x: r.left + r.width / 2, y: r.top + r.height / 2, t: Date.now() };
    }
  }, true);

  function burst(x, y) {
    if (reduce) return;
    var glyphs = ['✦', '✧', '♥', '✦', '✧', '✦', '♥', '✧'];
    for (var i = 0; i < 12; i++) {
      var s = document.createElement('span');
      var g = glyphs[i % glyphs.length];
      s.className = 'ga-spark' + (g === '♥' ? ' ga-spark--heart' : '');
      s.textContent = g;
      var ang = (Math.PI * 2 * i) / 12 + Math.random() * 0.4;
      var dist = 40 + Math.random() * 46;
      s.style.left = x + 'px';
      s.style.top = y + 'px';
      s.style.setProperty('--dx', Math.cos(ang) * dist + 'px');
      s.style.setProperty('--dy', Math.sin(ang) * dist - 18 + 'px');
      s.style.setProperty('--rot', (Math.random() * 120 - 60) + 'deg');
      s.style.fontSize = (12 + Math.random() * 10) + 'px';
      document.body.appendChild(s);
      setTimeout(function (el) { el.remove(); }.bind(null, s), 1000);
    }
  }

  function bounceCart() {
    var icon = document.querySelector('.header-actions__cart-icon, cart-icon, [href="/cart"], .header__icon--cart');
    if (!icon) return;
    icon.classList.remove('ga-bounce');
    void icon.offsetWidth;
    icon.classList.add('ga-bounce');
  }

  function celebrate() {
    var p = lastPoint && Date.now() - lastPoint.t < 6000 ? lastPoint : { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    burst(p.x, p.y);
    setTimeout(bounceCart, 250);
  }

  // Detect successful add-to-cart calls made by the theme.
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      return origFetch.apply(this, arguments).then(function (res) {
        try { if (/\/cart\/add/.test(url) && res.ok) celebrate(); } catch (e) {}
        return res;
      });
    };
  }

  // Review-break "Add to bag" buttons: sparkle, then continue to the cart.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('ga-pq__form')) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var r = btn.getBoundingClientRect();
    burst(r.left + r.width / 2, r.top + r.height / 2);
    btn.textContent = 'Added ✓';
    setTimeout(function () { form.submit(); }, reduce ? 0 : 450);
  });
})();
